import { createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5afed4cc")

_pushScopeId("data-v-5afed4cc")
const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "title" }, "🔐", -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "title" }, "CHANGE YOUR PASSWORD", -1)
const _hoisted_3 = { class: "field" }
const _hoisted_4 = { class: "control has-icons-left" }
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "icon is-small is-left" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-lock" })
], -1)
const _hoisted_6 = { class: "field" }
const _hoisted_7 = { class: "control has-icons-left" }
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "icon is-small is-left" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-lock" })
], -1)
const _hoisted_9 = {
  key: 0,
  class: "help is-danger",
  "data-testid": "reset-error"
}
const _hoisted_10 = {
  key: 0,
  class: "help is-success",
  "data-testid": "reset-error"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: 
      `box shadow content-center text-center border-solid ${
        _ctx.windowWidth < 769 ? 'box-mobile' : 'box-desktop'
      }`
    
  }, [
    _hoisted_1,
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _withDirectives(_createVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.password = $event)),
          class: 
            `input is-background-light-black has-text-white ${
              _ctx.error != '' ? 'is-danger' : ''
            }`
          ,
          type: "password",
          placeholder: "Password",
          "data-testid": "reset-password-input"
        }, null, 2), [
          [_vModelText, _ctx.password]
        ]),
        _hoisted_5
      ])
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode("div", _hoisted_7, [
        _withDirectives(_createVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.confirmPassword = $event)),
          class: 
            `input is-background-light-black has-text-white ${
              _ctx.error != '' ? 'is-danger' : ''
            }`
          ,
          type: "password",
          placeholder: "Confirm password",
          "data-testid": "reset-confirmPassword-input"
        }, null, 2), [
          [_vModelText, _ctx.confirmPassword]
        ]),
        _hoisted_8
      ]),
      (_ctx.error != '')
        ? (_openBlock(), _createBlock("p", _hoisted_9, _toDisplayString(_ctx.error), 1))
        : _createCommentVNode("", true)
    ]),
    (_ctx.resetPasswordError == 'succes')
      ? (_openBlock(), _createBlock("p", _hoisted_10, " Your password has been correctly changed "))
      : _createCommentVNode("", true),
    (_ctx.resetPasswordError != 'success')
      ? (_openBlock(), _createBlock("button", {
          key: 1,
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.resetPassword && _ctx.resetPassword(...args))),
          class: "button is-background-green no-border margin-t-24",
          "data-testid": "reset-submit-button"
        }, " SAVE CHANGES "))
      : (_openBlock(), _createBlock("button", {
          key: 2,
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('toggle-login'))),
          class: "button is-background-green no-border margin-t-24"
        }, " LOG IN "))
  ], 2))
})